import { useEffect, useMemo } from 'react';

import { useUserInfo, isNewUser } from '~domains/auth';

import {
  CHAT_SEGMENTS,
  ChatSegment,
  FEATURE_FLAG_ATTRIBUTES,
  growthBookInstance,
} from '~entities/growthbook';
import { useMerchantsListQuery } from '~entities/merchant';

export function useSyncChatSegment() {
  const { data: userInfo } = useUserInfo();
  const userHasRole = userInfo !== undefined && !isNewUser(userInfo);

  const { data: merchants } = useMerchantsListQuery({ enabled: userHasRole });

  const chatSegment: ChatSegment | null = useMemo(() => {
    if (!userInfo) {
      return null;
    }

    if (isNewUser(userInfo)) {
      return CHAT_SEGMENTS.NEW_USER;
    }

    if (!merchants) {
      return null;
    }

    return merchants.length > 0 && merchants.every((m) => m.segment === 'SME')
      ? CHAT_SEGMENTS.SME
      : CHAT_SEGMENTS.KA_OR_MIXED;
  }, [userInfo, merchants]);

  useEffect(() => {
    if (chatSegment) {
      growthBookInstance.updateAttributes({
        [FEATURE_FLAG_ATTRIBUTES.CHAT_SEGMENT]: chatSegment,
      });
    }
  }, [chatSegment]);
}
